import { render, staticRenderFns } from "./CourseGroups.vue?vue&type=template&id=10151942"
import script from "./CourseGroups.vue?vue&type=script&lang=js"
export * from "./CourseGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports